module.exports = __webpack_public_path__ + "img/induction.b18e4485.png";